export default "__VITE_ASSET__D6N_N4lZ__"